const CONSTANT = {
    OP: "Office Postings",
    CP: "Client Postings",
    BNKP: "Bank Postings",
    BP: "Batch Postings",
    PI: "Purchase Invoice",
    DIS: "Disbursements",
    TRANS: "Transfers",
}

export const NON_MATTER_POSTING_TYPES = ["BP", "BR", "BT", "PIN"];

export const LEDGER_ACTIONABLE_POSTING_TYPES = {
    NominalLedger: ["BP", "BR", "BT"],
    SupplierLedger: ["PIN"],
};

export const normalizePostingType = (postingType) =>
    String(postingType ?? "").toUpperCase();

export const isNonMatterPostingType = (postingType) =>
    NON_MATTER_POSTING_TYPES.includes(normalizePostingType(postingType));

export const canActionPostingFromLedger = (openingFrom, postingType) => {
    const allowedTypes = LEDGER_ACTIONABLE_POSTING_TYPES[openingFrom];
    if (!allowedTypes) return true;
    return allowedTypes.includes(normalizePostingType(postingType));
};

export default CONSTANT